import { Component, OnDestroy, OnInit } from '@angular/core';

import { Observable, Subject } from 'rxjs';

// Services
import { AuthService } from '../../../../providers/auth.service';
import { SharedClientService } from '../../shared/services/shared-client.service';
import { Plan } from '../upgrade-or-downgrade/store/package';

import { CreditCardState } from '../credit-card/store/credit-card-state';
import { default as swal } from 'sweetalert2';
import { CreditCardStateService } from '../credit-card/store/credit-card-state.service';
import { OnetimeOrder } from './OnetimeOrder';
import { stringify } from 'querystring';
import { SubscriptionState } from '../subscription/store/subscription-state';
import { BillingState } from '../store/billing-state';
import { BillingStateService } from '../store/billing-state.service';
import { SubscriptionStateService } from '../subscription/store/subscription-state.service';


export class OneTimeCreditsComponent implements OnInit, OnDestroy {
	public products: Plan[] = [];
	public onetimeOrders: OnetimeOrder[] = [];
	public loading = true;
	public actionInProgress = false;
	public creditCardState$: Observable<CreditCardState>;
	public state: SubscriptionState;
	public billingState: BillingState;
	private unsubscribe$ = new Subject();

	constructor(
		private authService: AuthService,
		private clientService: SharedClientService,
		private billingStateService: BillingStateService,
		private subscriptionStateService: SubscriptionStateService,
		private creditCardStateService: CreditCardStateService) { }

	public ngOnInit(): void {
		this.subscribeToBillingState();
		this.subscribeToState();

		this.getRequiredData();

		this.creditCardState$ = this.creditCardStateService.state$;
	}

	public ngOnDestroy(): void {
		this.unsubscribe$.next();
		this.unsubscribe$.complete();
	}

	public onBuyExtraCreditsClick(product) {
		this.actionInProgress = true;

		const data = {
			products: [
				{
					product_identifier: product.identifier,
					credits: +product.selectedCreditsAmount
				}
			]
		};

		this.clientService.orderClientBillingOnetimeProduct(String(this.authService.userId), data).subscribe(
		() => {
				this.actionInProgress = false;
				swal({
					title: '',
					html: `Extra credits purchased.`,
					type: 'success',
					showCancelButton: false,
					confirmButtonColor: '#008fb3',
					confirmButtonText: 'Close',
					allowOutsideClick: false,
					allowEscapeKey: false
				});

				this.getOrders();
			},
			() => this.actionInProgress = false
		);
	}

	public onCancelOrderClick(orderId: string) {
		if (this.actionInProgress) {
			return;
		}
		this.actionInProgress = true;

		this.clientService.cancelClientBillingOnetimeProductOrder(String(this.authService.userId), orderId).subscribe(
			() => {
				this.actionInProgress = false;
				swal({
					title: '',
					html: `Order cancelled.`,
					type: 'success',
					showCancelButton: false,
					confirmButtonColor: '#008fb3',
					confirmButtonText: 'Close',
					allowOutsideClick: false,
					allowEscapeKey: false
				});

				this.getOrders();
			},
			() => this.actionInProgress = false
		);
	}

	public reloadData() {
		this.getRequiredData();
	}

	private subscribeToState() {
		this.subscriptionStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.state = state;
			}
		);
	}

	private subscribeToBillingState() {
		this.billingStateService.state$.takeUntil(this.unsubscribe$).subscribe(
			(state) => {
				this.billingState = state;
			}
		);
	}

	private getRequiredData() {
		this.loading = true;
		Observable.forkJoin(
			this.clientService.getClientBillingOnetimeProducts(String(this.authService.userId)),
			this.clientService.getClientBillingOnetimeProductOrders(String(this.authService.userId))
		).subscribe(
			([products, orders]) => {
				this.onetimeOrders = orders;
				if (!products || !Object.keys(products)) {
					this.products = [];
					this.loading = false;

					return;
				}
				let plans = [];
				Object.keys(products).forEach((prodkey) => {
					const prod = products[prodkey];
					if (!prod.product_template || !prod.product_template.plan) {
						return;
					}

					let toShowProduct = {
						...prod.product_template.plan,
						credits: Object.keys(prod.product_template.plan.credits).map((creditKey) => prod.product_template.plan.credits[creditKey])
					};
					toShowProduct.selectedCreditsAmount = toShowProduct.credits[0].credits;

					plans.push(toShowProduct);
				});

				this.products = plans;
				this.loading = false;
			},
			() => this.loading = false
		);
	}

	private getOrders() {
		this.clientService.getClientBillingOnetimeProductOrders(String(this.authService.userId)).subscribe(
			(orders) => {
				this.onetimeOrders = orders;
			}
		);
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedClientService }, { type: BillingStateService }, { type: SubscriptionStateService }, { type: CreditCardStateService } ]; }}



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/billing/one-time-credits/one-time-credits.component.ts